import { ContentContext } from "../../../../../utils/contexts";

const { Breadcrumbs: MUIBreadcrumbs, Button, IconButton, withStyles } = window.Material;
const { ChevronLeft } = window.MaterialIcons;
const { NavigateNext } = window.MaterialIcons;
import Dropdown from './Dropdown';

const styles = {
  button: {
    textTransform: 'none',
    padding: '5px 5px !important',
    margin: '0 !important',
    minWidth: 'auto !important',
  },
  separator: {
    margin: '0',
  },
};

class Breadcrumbs extends React.PureComponent {
  render() {
    const { classes } = this.props;
    const { breadcrumbs, onBreadcrumbClick, loadingContent } = this.context;

    const isSiteRoot = breadcrumbs.length <= 1;

    return (
      <div className="Breadcrumbs">
        <IconButton onClick={() => onBreadcrumbClick(breadcrumbs[breadcrumbs.length - 2])} disabled={isSiteRoot || loadingContent} id="backBtn">
          <ChevronLeft fontSize="small" />
        </IconButton>
        <MUIBreadcrumbs classes={{ separator: classes.separator }} separator={<NavigateNext fontSize="small" />}>
          {breadcrumbs.length <= 5
            ? breadcrumbs.map((item, index) => (
                <Button
                  classes={{ root: classes.button }}
                  key={index}
                  onClick={() => onBreadcrumbClick(item)}
                  id={`breadcrumbs${index}`}
                  disabled={loadingContent}
                >
                  {item.name}
                </Button>
              ))
            : [
                <Button
                  classes={{ root: classes.button }}
                  onClick={() => onBreadcrumbClick(breadcrumbs[0])}
                  key={breadcrumbs[0].nodeRef}
                  id={`breadcrumbs${0}`}
                  disabled={loadingContent}
                >
                  {breadcrumbs[0].name}
                </Button>,
                <Dropdown
                  folders={breadcrumbs.slice(1, breadcrumbs.length - 1)}
                  onClick={onBreadcrumbClick}
                  key={breadcrumbs.length - 2}
                />,
                <Button
                  classes={{ root: classes.button }}
                  onClick={() => onBreadcrumbClick(breadcrumbs[breadcrumbs.length - 1])}
                  key={breadcrumbs.length - 1}
                  id={`breadcrumbs${breadcrumbs.length - 1}`}
                  disabled={loadingContent}
                >
                  {breadcrumbs[breadcrumbs.length - 1].name}
                </Button>,
              ]}
        </MUIBreadcrumbs>
      </div>
    );
  }
}

Breadcrumbs.contextType = ContentContext;

export default withStyles(styles)(Breadcrumbs);
